module.exports = __webpack_public_path__ + "media/assets/images/flags/vc-58b01798f892a93a5a274b9c32d8f230.svg";